import localforage from 'localforage'
// src is a alias. see client/build/webpack.base.conf.js
import { userTokenStorageKey } from 'src/config'
import { readStoredUser } from 'src/utils/storedUser'
import { isEmpty } from 'lodash'
import * as TYPES from './mutations-types'
import * as services from '../services'
import { resetBanner } from 'src/utils/systemAlertBanner'

export const attemptLogin = ({ dispatch }, payload) =>
    services.postLogin(payload)
    .then((response) => {
      return response;
    })

export const attemptLearningLogin = ({ dispatch }, payload) =>
    services.postLearningLogin(payload)
    .then((response) => {
      return response;
    })

export const attemptRegister = ({ dispatch }, payload) =>
    services.postRegister(payload)
    .then( (response) => {
      return response // keep promise chain
    })

export const loginUser = ({ dispatch }, response) => {
      dispatch('setToken', response.data.token)
      dispatch('setUser', response.data)
      localStorage.setItem('user', JSON.stringify(response.data));
    }


export const attemptVerification = ({ dispatch }, payload) =>
    services.postVerification(payload)
    .then((response) => {
      dispatch('setToken', null)
      dispatch('setToken', response.data.token)
      dispatch('setUser', response.data)
      localStorage.setItem('user', JSON.stringify(response.data));
      localStorage.setItem('quickStart', 1);

      return response // keep promise chain
    })


export const logout = ({ dispatch }) => {
  services.revokeToken();

  // Remove existing df_* cookies first
  var existingCookies = document.cookie.split(";");

  for (var i = 0; i < existingCookies.length; i++) {
    var cookiePair = existingCookies[i].trim();
    // Extract just the cookie name (before the = sign)
    var cookieName = cookiePair.split("=")[0];

    if (cookieName.indexOf("df_") === 0) {
      // Get the main domain (remove subdomain)
      var hostname = window.location.hostname;
      var mainDomain = hostname.split(".").slice(-2).join(".");
    console.log(hostname);
      // Remove cookie with different possible paths and domains
      document.cookie =
        cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie =
        cookieName +
        "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" +
        mainDomain;
      document.cookie =
        cookieName +
        "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=." +
        mainDomain;
    }
  }
  // Closing the system alert banner only lasts for one sign-in, so forget it
  // here. Whoever signs in next sees the banner again if the problem is still
  // there. Deliberately not in setToken(): a page reload goes through that too.
  resetBanner()

  // call actions
  return Promise.all([dispatch("setToken", null), dispatch("setUser", {})]);
}

export const setUser = ({ commit }, user) => {
  // Commit the mutations
  commit(TYPES.SET_USER, user)

  Promise.resolve(user) // keep promise chain
}

export const setToken = ({ commit }, payload) => {

  // prevent if payload is a object
  const token = (isEmpty(payload)) ? null : payload.token || payload

  // Commit the mutations
  commit(TYPES.SET_TOKEN, token)

  return Promise.resolve(token) // keep promise chain
}

export const checkUserToken = ({ dispatch, state }) => {

  // If the token exists then all validation has already been done
  if (!isEmpty(state.token)) {
    return Promise.resolve(state.token)
  }

  /**
   * Token does not exist yet
   * - Recover it from localstorage
   * - Recover also the user, validating the token also
   */
  return localforage.getItem(userTokenStorageKey)
    .then((token) => {
      if (isEmpty(token)) {
        // Token is not saved in localstorage
        return Promise.reject('NO_TOKEN') // Reject promise
      }
      // Put the token in the vuex store
      return dispatch('setToken', token) // keep promise chain
    })
    // With the token in hand, retrieves the user's data, validating the token
    .then(() => dispatch('loadUser'))
}

/**
 * Retrieves updated user information
 * If something goes wrong, the user's token is probably invalid
 */
export const loadUser = ({ dispatch }) => {
  // Deliberately dispatches null when the record is missing rather than substituting {}:
  // NavBar reads a falsy currentUser as "this session is not usable" and redirects to login,
  // which is how the app recovers. An empty object would pass that check and strand the user
  // on a half-rendered page with no way back.
  const user = readStoredUser()
  return Promise.resolve( dispatch('setUser', user) )
}


// services.loadUserData()
//   // store user's data
//   .then(user => dispatch('setUser', user.data))
//   .catch(() => {
//     // Process failure, delete the token
//     dispatch('setToken', '')
//     return Promise.reject('FAIL_IN_LOAD_USER') // keep promise chain
//   })



// WEBPACK FOOTER //
// ./src/app/auth/vuex/actions.js